import type { LngLat } from "../adapters/types";

const EARTH_RADIUS_METERS = 6_378_137;

function toMercator([lng, lat]: LngLat): [number, number] {
  return [
    (EARTH_RADIUS_METERS * lng * Math.PI) / 180,
    EARTH_RADIUS_METERS * Math.log(Math.tan(Math.PI / 4 + (lat * Math.PI) / 360)),
  ];
}

function fromMercator([x, y]: [number, number]): LngLat {
  return [
    (x / EARTH_RADIUS_METERS) * (180 / Math.PI),
    (2 * Math.atan(Math.exp(y / EARTH_RADIUS_METERS)) - Math.PI / 2) * (180 / Math.PI),
  ];
}

/** Déplace `points` de la translation qui mène `from` à `to`, mesurée dans le plan de la carte
 * (Web Mercator) : la forme garde exactement son dessin, là où un même écart en lng/lat l'étirerait. */
export function translateOnGround(points: LngLat[], from: LngLat, to: LngLat): LngLat[] {
  const [fromX, fromY] = toMercator(from);
  const [toX, toY] = toMercator(to);
  const dx = toX - fromX;
  const dy = toY - fromY;
  return points.map((point) => {
    const [x, y] = toMercator(point);
    return fromMercator([x + dx, y + dy]);
  });
}
